import jsonPointer from 'json-pointer'

const get = (jsonSchema,ref)=>{
  ref=ref.replace('#','');
  if(!ref || ref==='/') return jsonSchema;
  return jsonPointer.get(jsonSchema,ref);
};

const has = (jsonSchema,ref)=>{
  ref = ref.replace("#","");
  return jsonPointer.has(jsonSchema,ref);
};

const parse = (ref)=>{
  ref = ref.replace("#","");
  return jsonPointer.parse(ref);
};

export default {
  get,
  has,
  parse
}
